<template>
  <div class="ksm-deepzoom__page-wrapper ksm-flex-column" @dblclick="stopDblClick">
    <div class="ksm-flex-1" v-show="noFacimilie" style="position:relative; text-align:center">
      <div class="ksm-position-absolute">
        <img :src="noFacimilie" style="height:auto; width:auto; max-height:100%; max-widht:100%">
      </div>
    </div>
    <!-- <div v-if="showLoading" style="margin:50px 50px; z-index: 100; position:absolute;">
      <img src="~icons/loading.gif" style="height:20px">
    </div>-->
    <div
      ref="toolbarDiv"
      class="toolbarDiv ksm-disable-select ksm-flex-00auto"
      style="position:relative; height:40px; width:280px"
      v-show="!noFacimilie"
    ></div>
    <div class="ksm-deepzoom__page ksm-flex-1" v-show="!noFacimilie">
      <div class="ksm-position-absolute ksm-flex">
        <div :id="containerId" class="ksm-deepzoom__body ksm-flex-1"></div>
      </div>
    </div>
    <div style="display:none">
      <div ref="infobox_template" class="ksm-gummi__end-overlay" :class="modusOption.key">
        <div class="__head ksm-flex">
          <div class="__title ksm-flex-1 ksm-flex"></div>
          <div class="__close-infobox">x</div>
        </div>
        <div class="__body ksm-hyphens"></div>
      </div>
      <div ref="popup-menu_template" class="ksm-deepzoom__popupmenu-overlay">
        <div class="ksm-flex">
          <div class="ksm-deepzoom__popupmenu__color-rect"></div>
          <div class="ksm-deepzoom__popup-menuitem"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CanvasOverlay from "../utils/openseadragon.canvasOverlay";
require("../vendor/openseadragon-svg-overlay");
import Vue from "vue";
import * as d3 from "d3";

import {
  Observable,
  Subject,
  ReplaySubject,
  fromEvent,
  of,
  range,
  from,
  pipe
} from "rxjs";

import { map, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { mapActions } from "vuex";

export default {
  props: {
    seiten: {
      type: Array
    },
    seiteIdx: {
      type: Number
    },
    modusOption: {
      type: Object
    }
  },
  data() {
    return {
      stopDobbledrawTranscripts: false,
      inChangingMerz: false,
      openedSeite: null,
      accordionidTranscriptMap: null,
      transcripts: [], //trainscipt mit Inhalten
      mouseRelatedTranscriptIDs: null,
      mouseTargetAccoItems: [],
      mouseTargetTranscripts: null,
      markedTranscriptList: [],
      markedTranscripts: [],
      zIndex: 2000
    };
  },

  /************************************************************* *************************************************************
   ***************************************************** watch *************************************************************
   ************************************************************* *************************************************************
   */
  watch: {
    /**
     *********** watch *********
     */
    seiten() {
      //update tiles
      if (this.viewer) {
        this.inChangingMerz = true;
        this.viewer.clearOverlays();
        if (this.$svgRootG) {
          this.$svgRootG.selectAll("*").remove();
        }
        this.viewer.drawer.clear();
        const seite = this.seite;
        let idx = 0;
        if (seite && seite.idx) {
          idx = seite.idx;
        }
        this.viewer.open(this.tiles);
        this.viewer.goToPage(idx);
      }
    },

    /*
     ************ watch *********
     */
    seite(seite, oldSeite) {
      //update Page
      if (!seite) {
        return;
      }

      if (this.inChangingMerz) {
        this.inChangingMerz = false;
        return; // 有问题 TODO 为什么不能用？？
      }
      if (this.viewer) {
        this.viewer.clearOverlays();
      }
      if (this.stopDobbledrawTranscripts) {
        this.stopDobbledrawTranscripts = false;
        return;
      }

      this._openPage(seite.idx);
    },

    /**
     *********** watch *********
     */
    checkedTranscriptIDs(ids) {
      const data = this._getTranscriptByIDs(ids);
      this._drawCanvasOverlayers(this.canvasoverlay_checked, data);
    },

    /**
     *********** watch *********
     */
    mouseTargetAccoItems(data) {
      if (this.isKomposition) {
        return;
      }
      this.$store.state.eventBus.$emit(
        [
          "mouseover.transcripts",
          this.modusOption.viewKey,
          this.modusOption.key
        ].join("-"),
        data
      );
    },

    /**
     *********** watch *********
     */
    mouseRelatedTranscriptIDs(ids) {
      if (this.isKomposition) {
        return;
      }
      const data = this._getTranscriptByIDs(ids);
      this._drawCanvasOverlayers(this.canvasoverlay_mouseover, data);
    },

    /**
     *********** watch *********
     */
    markedTranscriptList(list) {
      let ids = [];
      this.markedTranscriptList.forEach(arr => {
        ids = ids.concat(arr);
      });
      const data = this._getTranscriptByIDs(ids);
      this.markedTranscripts = data;
      this._drawCanvasOverlayers(this.canvasoverlay_marked, data);
    },

    /**
     *********** watch *********
     */
    transparenz(val) {
      if (this.modusOption.key === "untersuchung") {
        this._setTransparent();
      }
    },

    /**
     *********** watch *********
     */
    checkedTranscriptKategorieMap(a) {
      this._drawColorRect();
      this._setPopupBox(a);
    }
  },

  /************************************************************* *************************************************************
   ***************************************************** mounted *************************************************************
   ************************************************************* *************************************************************
   */
  mounted: function() {
    const vue = this;
    const opt = this.modusOption;
    this.$store.state.eventBus.$on(
      ["mouseover.sidebar", opt.viewKey, opt.key].join("-"),
      function(ids) {
        vue._drawCanvasOverlayers(
          vue.canvasoverlay_mouseover,
          vue._getTranscriptByIDs(ids)
        );
      }
    );
    this.$store.state.eventBus.$on(
      ["marknote.sidebar", opt.viewKey, opt.key].join("-"),
      function(ids) {
        vue._drawCanvasOverlayers(
          vue.canvasoverlay_checked,
          vue._getTranscriptByIDs(ids)
        );
      }
    );
    this.$store.state.eventBus.$on("keydown", function(event) {
      if (event.ctrlKey) {
        if (event.keyCode === 39) {
          let idx = vue.seiteIdx;
          if (idx < vue.seiten.length - 1) {
            vue.$emit("changePage", idx + 1);
          }
        } else if (event.keyCode === 37) {
          let idx = vue.seiteIdx;
          if (idx > 0) {
            vue.$emit("changePage", idx - 1);
          }
        }
      }
    });

    this.$store.state.eventBus.$on(
      ["mouseclick.sidebar", opt.viewKey, opt.key].join("-"),
      function(ids) {
        const trs = ids.split(",");
        vue._updatemarkedTranscriptList(trs, trs);
      }
    );

    this._initViewer();
  },
  /************************************************************* *************************************************************
   ***************************************************** computed *************************************************************
   ************************************************************* *************************************************************
   */
  computed: {
    /************ computed *********
     *
     */
    noFacimilie() {
      const merzId = this.$route.query.merzId;
      if (merzId === "Merz22") {
        return this.$_getIcon("merz22.png");
      } else if (merzId === "Merz23") {
        return this.$_getIcon("merz23.png");
      }
    },

    OSDTooltips() {
      return this.$store.state["OSDTooltips"];
    },
    /************ computed *********
     *
     */
    // active_modus() {
    //   return this.$store.state.modus.active_modus;
    // },
    /************ computed *********
     *
     */
    checkedTranscriptAccordionIDs() {
      let out = [];
      this.modusOption.accordionList.forEach(item => {
        if (item.transcriptButtonChecked) {
          out.push(item.id);
        }
      });
      return out;
    },

    /************ computed *********
     *
     */
    checkedKategorieAccordionIDs() {
      let out = [];
      this.modusOption.accordionList.forEach(item => {
        if (item.kategorieButtonChecked) {
          out.push(item.id);
        }
      });
      return out;
    },

    /************ computed *********
     *
     */
    checkedTranscriptIDs() {
      const map = this.accordionidTranscriptMap;
      if (!map) {
        return;
      }
      let out = [];
      this.checkedTranscriptAccordionIDs.forEach(c => {
        let group = map[c];
        if (group) {
          group.forEach(item => {
            out = out.concat(item.ids);
          });
        }
      });
      return out;
    },

    /************ computed *********
     *
     */
    checkedTranscriptKategorieMap() {
      const map = this.accordionidTranscriptMap;
      if (!map) {
        return;
      }
      const out = {};
      const accoIds = this.checkedKategorieAccordionIDs;
      const list = []; //checked accordion items
      const allTrs = this.transcripts;

      const idsObj = {};
      accoIds.forEach(ac => {
        const items = map[ac];
        if (items) {
          items.forEach((item, i) => {
            const ids = item.ids;
            if (ids.length < 1) {
              return;
            }
            let trs = allTrs.filter(tr => ids.indexOf(tr.id) > -1);
            trs.sort((a, b) => {
              return a.x * a.x + a.y * a.y - (b.x * b.x + b.y * b.y);
            });
            ids.forEach(id => {
              idsObj[id] = true;
            });

            //suche erste
            out[trs[0].id] = {
              accoItems: [
                {
                  acco: ac,
                  accoItemIdx: i,
                  first: true
                }
              ],
              data: trs[0]
            };

            list.push({
              acco: ac,
              ids: ids,
              trs: trs,
              accoItemIdx: i
            });
          }); //items.forEach end
        }
      });

      Object.keys(idsObj).forEach(id => {
        list.forEach((li, i) => {
          const { acco, ids, trs, accoItemIdx } = li;
          const outItem = out[id];
          if (ids.indexOf(id) < 0) {
            return;
          }

          if (outItem) {
            //hat Überschneidung
            // Überlagerung verschiedener Notiztypen?
            if (outItem.data === null) {
              outItem.data = trs.find(tr => tr.id === id);
            }
            const has = outItem.accoItems.find(oi => {
              return oi.acco === acco && accoItemIdx === accoItemIdx;
            });
            if (has) {
              return;
            } else {
              outItem.accoItems.push({
                acco: acco,
                accoItemIdx: accoItemIdx
              });
            }
          } else {
            return;
            // unbekannte Funktion:
            //neu
            out[id] = {
              accoItems: [
                {
                  acco: acco,
                  accoItemIdx: accoItemIdx,
                  first: true
                }
              ],
              data: null
            };
          }
        });
      });

      const out2 = {};
      for (const id in out) {
        if (out[id].data !== null) {
          out2[id] = out[id];
        }
      }

      return out2;
    },

    /************ computed *********
     *
     */
    seite() {
      if (this.seiteIdx != undefined && this.seiten) {
        return this.seiten[this.seiteIdx];
      }
      // this.stopDobbledrawTranscripts = true;
    },

    /************ computed *********
     *
     */
    docs() {
      if (!this.seite) {
        return;
      }
      return this.seite.$_docInfo;
    },

    /************ computed *********
     *
     */
    tiles() {
      if (!this.seiten) {
        return;
      }
      return this.seiten.map(d => {
        return d.deepSrc;
      });
    },

    /************ computed *********
     *
     */
    containerId() {
      return this.$_getRandomId();
    },

    /************ computed *********
     *
     */
    transparenz() {
      const t = this.modusOption.transparenz;
      return t !== undefined ? t / 100 : 1;
    },

    /************ computed *********
     *
     */
    isUntersuchung() {
      return this.modusOption.key === "untersuchung";
    },

    /************ computed *********
     *
     */
    isKomposition() {
      return this.modusOption.key === "komposition";
    }
  },

  /************************************************************* *************************************************************
   ***************************************************** Methods *************************************************************
   ************************************************************* *************************************************************
   */
  methods: {
    stopDblClick(e) {
      e.preventDefault();
      e.stopPropagation();
    },

    /**
     *
     */
    _removeAllDraggableElement() {
      const divs = document.body.querySelectorAll(
        ".ksm-komposition__draggable-div"
      );
      if (divs) {
        [].forEach.call(divs, function(d) {
          document.body.removeChild(d);
        });
      }
    },

    /**
     *
     */
    _createDraggableDiv(div, ctx, x, y, w, h, trID) {
      const bound = div.getBoundingClientRect();
      const dragDiv = document.createElement("div");
      dragDiv.className = "ksm-komposition__draggable-div";
      dragDiv.setAttribute("data-trid", trID);
      dragDiv.style.left = bound.left + "px";
      dragDiv.style.top = bound.top + "px";
      dragDiv.style.width = bound.width + "px";
      dragDiv.style.height = bound.height + "px";
      dragDiv.classList.add("dragging");
      const imgData = ctx.getImageData(x, y, w, h);
      const imgCanvas = document.createElement("canvas");
      imgCanvas.setAttribute("id", "_temp_canvas");
      imgCanvas.width = w;
      imgCanvas.height = h;
      imgCanvas.getContext("2d").putImageData(imgData, 0, 0);
      dragDiv.appendChild(imgCanvas);
      document.body.appendChild(dragDiv);
      return dragDiv;
    },

    /**
     *
     */
    _drawDraggleTranscripts(trs) {
      const viewer = this.viewer;
      viewer.clearOverlays();
      const _drag = document.body.querySelector(
        ".ksm-komposition__draggable-div.dragging"
      );
      if (_drag) {
        // document.body.removeChild(_drag);
      }

      if (!trs) {
        return;
      }

      const vue = this;
      const viewport = viewer.viewport;
      const ctx = viewer.drawer.context;

      trs.forEach(tr => {
        const pos = viewport.imageToViewerElementCoordinates(
          new OpenSeadragon.Point(tr.x, tr.y)
        );
        const viewportZoom = viewport.getZoom(true);
        const rotate = viewport.getRotation();
        const image1 = viewer.world.getItemAt(0);
        const zoom = image1.viewportToImageZoom(viewportZoom);

        const [x, y, w, h] = [
          Number(pos.x),
          Number(pos.y),
          tr.w * zoom,
          tr.h * zoom
        ];

        if (x < 0 || y < 0 || w <= 0 || h <= 0) {
          return;
        }
        const div = document.createElement("div");
        div.className = "ksm-komposition__focus-transcript";
        const trID = tr.id;
        new OpenSeadragon.MouseTracker({
          element: div,
          moveHandler: function(e) {
            const dragDiv = document.body.querySelector(
              ".ksm-komposition__draggable-div.dragging"
            );

            if (dragDiv && this.userData) {
              const left =
                e.originalEvent.clientX - this.userData.startPoint.x + "px";
              const top =
                e.originalEvent.clientY - this.userData.startPoint.y + "px";
              d3.select(dragDiv)
                .style("left", left)
                .style("top", top);
            }
          },
          clickHandler: function(e) {
            if (e.originalEvent.ctrlKey) {
              return;
              vue._removeAllDraggableElement();
              const dragDiv = vue._createDraggableDiv(
                div,
                ctx,
                x,
                y,
                w,
                h,
                trID
              );
              dragDiv.classList.add("ksm-komposition__fly-div");
              vue.$emit("eventFromOSDViewer", {
                type: "transcript-double-click",
                data: trs,
                dragDiv: dragDiv
              });

              e.preventDefaultAction = true;
              e.originalEvent.stopPropagation();
              e.originalEvent.preventDefault();
            }
          },
          dblClickHandler: function(e) {
            return;
            vue._removeAllDraggableElement();
            const dragDiv = vue._createDraggableDiv(div, ctx, x, y, w, h, trID);
            dragDiv.classList.add("ksm-komposition__fly-div");
            vue.$emit("eventFromOSDViewer", {
              type: "transcript-double-click",
              data: trs,
              dragDiv: dragDiv
            });

            e.preventDefaultAction = true;
            e.originalEvent.stopPropagation();
            e.originalEvent.preventDefault();
          },
          dragHandler: function(e) {
            if (this.userData) {
              return;
            }
            this.userData = {
              startPoint: e.position
            };
            const dragDiv = vue._createDraggableDiv(div, ctx, x, y, w, h, trID);
          },
          releaseHandler: function(e) {
            this.userData = null;

            const dragDiv = document.body.querySelector(
              ".ksm-komposition__draggable-div"
            );
            dragDiv &&
              vue.$emit("eventFromOSDViewer", {
                type: "dragTranscriptElementEnd",
                div: dragDiv,
                event: e.originalEvent
              });
          },
          dragEndHandler: function(e) {
            this.userData = null;
            const dragDiv = document.body.querySelector(
              ".ksm-komposition__draggable-div"
            );

            dragDiv &&
              vue.$emit("eventFromOSDViewer", {
                type: "dragEnd",
                div: dragDiv,
                event: e.originalEvent
              });
          }
        }).setTracking(true);

        viewer.addOverlay({
          element: div,
          px: tr.x,
          py: tr.y,
          width: tr.w,
          height: tr.h
        });
      });
    },

    /**
     * @param {array} ids
     */
    _getTranscriptByIDs(ids) {
      if (!this.transcripts || !ids) {
        return;
      }

      return this.transcripts.filter(tr => {
        return ids.indexOf(tr.id) > -1;
      });
    },

    /**
     *
     */
    _getTargetAccoItems(id) {
      const map = this.accordionidTranscriptMap;
      if (!map) {
        return;
      }
      let out = [];
      for (let k in map) {
        const accoItems = map[k];
        accoItems.forEach(item => {
          if (item.ids.indexOf(id) > -1) {
            out.push({
              accoID: k,
              accoItemIdx: item.ID,
              ids: item.ids
            });
          }
        });
      }
      return out;
    },

    /**
     *
     */
    _getRelatedTranscriptIDs(id) {
      let out = [];
      this.mouseTargetAccoItems.forEach(item => {
        out = out.concat(item.ids);
      });
      return out;
      // const map = this.accordionidTranscriptMap;
      // if (!map) {
      //   return;
      // }
      // let out = [];
      // for (let k in map) {
      //   const arr = map[k];
      //   arr.forEach(ar => {
      //     if (ar.ids.indexOf(id) > -1) {
      //       out = out.concat(ar.ids);
      //     }
      //   });
      // }
      // return out;
    },

    /**
     * transcripts für aktuelle view definieren.
     *
     */
    updateDataForCurrentView(seite) {
      //current  accordionidTranscriptMap und transcriptIdList
      let currentMap = {};
      let idList = [];
      const map = seite.$_accoId_transcript_mapping;
      if (map) {
        this.modusOption.accordionList.forEach(accordion => {
          let trs = [];
          accordion.fudkeys.forEach(k => {
            const arr = map[k];
            if (arr) {
              trs = trs.concat(arr);
              arr.forEach(ar => {
                idList = idList.concat(ar.ids);
              });
            }
          });
          currentMap[accordion.id] = trs;
        });
      }
      let _filterTranscripts = [];
      if (this.isKomposition || this.modusOption.key === "simple") {
        seite.$_allTranscripts.forEach(it => {
          _filterTranscripts = _filterTranscripts.concat(it.transcripts);
        });
      } else {
        seite.$_allTranscripts.forEach(it => {
          let tmp = it.transcripts.filter(tr => {
            return idList.indexOf(tr.id) > -1;
          });
          _filterTranscripts = _filterTranscripts.concat(tmp);
        });
      }
      this.transcripts = _filterTranscripts;
      this.accordionidTranscriptMap = currentMap;
      this.markedTranscriptList = [];
    },

    /**
     *
     */
    _setTransparent() {
      this._drawCanvasOverlayers(
        this.canvasoverlay_marked,
        this.markedTranscripts
      );
      // this.$svgMask
      //   .select('.mask-background')
      //   .attr('opacity', this.transparenz);
    },

    /**
     *
     */
    _isPointInTranscript(tr, imagePoint) {
      const { x, y, w, h } = tr;
      return (
        imagePoint.x >= x &&
        imagePoint.x <= x + w &&
        imagePoint.y >= y &&
        imagePoint.y <= y + h
      );
    },

    /**
     *
     */
    _openPage(idx) {
      const vue = this;
      setTimeout(function() {
        vue.viewer.goToPage(idx);
      }, 300);
    },

    /**
     *
     */
    _getTranscriptsUnderMouse(pos) {
      if (!pos) {
        return;
      }
      const viewport = this.viewer.viewport;
      const imagePoint = viewport.viewportToImageCoordinates(
        viewport.pointFromPixel(pos)
      );
      const _isPointInTranscript = this._isPointInTranscript;
      const trs = this.transcripts.filter(tr => {
        return _isPointInTranscript(tr, imagePoint);
      });
      if (trs && trs.length > 1) {
        trs.sort((a, b) => {
          return (
            a.x < b.x &&
            a.y < b.y &&
            a.x + a.w > b.x + b.w &&
            a.y + a.h > b.y + b.h
          );
        });
        return [trs[0]];
      }
      return trs;
    },

    /**
     *
     */
    _canvasClick(event) {
      const vue = this;
      if (
        !vue.isUntersuchung &&
        vue.modusOption.key !== "vergleich" &&
        vue.modusOption.key !== "b_vergleich"
      ) {
        return;
      }

      const popup = this.$el.querySelector(".ksm-deepzoom__popupmenu-overlay");
      let target = event.originalEvent.target;
      if (target.classList.contains("kategorie-rect")) {
        if (popup) {
          this.viewer.removeOverlay(popup);
        }
        return vue._createMenu(event);
      } else if (target.classList.contains("ksm-deepzoom__popup-menuitem")) {
        if (popup) {
          this.viewer.removeOverlay(popup);
        }
        const menuItem = target;
        return vue._openInfoBox(
          {
            gummiID: menuItem.getAttribute("data-gummi-id"),
            accoID: menuItem.getAttribute("data-acco-id"),
            accoItemIdx: menuItem.getAttribute("data-accoitem-idx")
          },
          event
        );
      } else {
        while (target) {
          if (
            target.classList &&
            target.classList.contains("ksm-deepzoom__popupmenu-overlay")
          ) {
            return;
          }
          target = target.parentNode;
        }
      }

      if (popup) {
        this.viewer.removeOverlay(popup);
      }

      const relatedIDs = vue.mouseRelatedTranscriptIDs;
      vue.$store.state.eventBus.$emit(
        [
          "mouseclick.transcripts",
          vue.modusOption.viewKey,
          vue.modusOption.key
        ].join("-"),
        relatedIDs
      );

      const targetTrs = this.mouseTargetTranscripts;
      const targetTrIDs = targetTrs ? targetTrs.map(tr => tr.id) : [];
      this._updatemarkedTranscriptList(targetTrIDs, relatedIDs);
    },

    /**
     *
     */
    _updatemarkedTranscriptList(targetTrIDs, relatedIDs) {
      const vue = this;
      const markedTranscriptList = vue.markedTranscriptList;
      let makeMark = true;
      if (targetTrIDs) {
        markedTranscriptList.forEach((arr, i) => {
          targetTrIDs.forEach(tr_id => {
            if (arr.indexOf(tr_id) > -1) {
              markedTranscriptList.splice(i, 1);
              makeMark = false;
            }
          });
        });
      }

      if (makeMark) {
        markedTranscriptList.push(relatedIDs);
      }
    },

    /**
     *
     */
    _drawColorRect() {
      const map = this.checkedTranscriptKategorieMap;
      const vue = this;
      const viewer = this.viewer;
      const currentOverlays = this.viewer.currentOverlays;
      const list = this.$el.querySelectorAll(".ksm-gummi__start-overlay");
      list.forEach(el => {
        this.viewer.removeOverlay(el);
      });
      Object.keys(map).forEach(trID => {
        const tr = map[trID].data;
        const el = document.createElement("div");
        el.setAttribute("data-tr-id", trID);
        el.className = "ksm-gummi__start-overlay";
        vue._drawOneColorRect(el, tr, map[trID].accoItems);
      });
    },

    /**
     *
     */
    _createInfoBox(infoFensterData, event) {
      const { gummiID, accoItemIdx, accoID } = infoFensterData;
      const vue = this;
      const { viewer } = this;
      const viewport = viewer.viewport;
      const trID = gummiID.split("#")[1];
      const accordion = vue.modusOption.accordionList.find(
        ac => ac.id === accoID
      );

      //wenn ohne start_overlay
      const start_overlay = this.$el.querySelector(
        '.ksm-gummi__start-overlay[data-tr-id="' + trID + '"]'
      );
      if (!start_overlay) {
        return;
      }

      const fudkeys = accordion.fudkeys;

      const obj = vue.accordionidTranscriptMap[accoID].find((obj, idx) => {
        return (
          obj.ids.indexOf(trID) > -1 && Number(accoItemIdx) === Number(idx)
        );
      });

      let innerHTML = "";
      if (accoID === "acco_personen" || accoID === "acco_orte") {
        const pers = vue.$store.getters["modus/getSeiteDataExtendInfo"](
          vue.seite,
          accoID.replace("acco_", "")
        );
        if (!pers) {
          return;
        }
        pers.forEach(p => {
          if (p.transcripts && p.transcripts.length > 0) {
            p.$_html =
              '<span style="border:1px solid transparent; padding:2px; margin:2px" class="div-with-transcript" data-transcript="';
            p.$_html += p.transcripts.join(",");
            p.$_html += '">' + p.content + "</span>";
            if (p.transcripts.indexOf(gummiID.split("#")[1]) > -1) {
              innerHTML = p.$_html;
            }
          } else {
            p.$html = p.content;
          }
        });
      } else {
        this.seite.$_docInfo.forEach(doc => {
          const notes = doc._source.notes;
          notes &&
            notes
              .filter(n => {
                return (
                  fudkeys.indexOf(n.category) > -1 &&
                  Number(n.ID) === Number(obj.ID)
                );
              })
              .forEach(n => {
                let cat = n.category;
                let div = this.$_getNewHtmlElement(n.html, vue.merz, doc, true);
                div.classList.add("ksm-accordion__section");
                innerHTML = div.innerHTML;
              });
        });
      }

      const template = vue.$refs["infobox_template"];
      const infobox = template.cloneNode(true);
      this.zIndex++;
      infobox.style.zIndex = this.zIndex;

      infobox.setAttribute("data-gummi-id", gummiID);
      infobox.setAttribute("data-accoid", accoID);
      infobox
        .querySelector(".__close-infobox")
        .addEventListener("click", function() {
          viewer.removeOverlay(infobox);
          const line = vue.$el.querySelector(
            '.ksm-gummi__line[data-gummi-id="' + gummiID + '"]'
          );
          d3.select(line).remove();
        });
      infobox.querySelector(".__title").innerHTML =
        '<div class="ksm-deepzoom__popupmenu__color-rect ' +
        accoID +
        ' _bg"></div><div>' +
        accordion.label +
        "</div>";
      infobox.querySelector(".__body").innerHTML = innerHTML;
      new OpenSeadragon.MouseTracker({
        element: infobox,
        clickHandler: function(e) {
          let _target = e.originalEvent.target;
          if (_target.tagName.toLowerCase() !== "a") {
            _target = _target.closest("a");
          }

          if (_target && _target.getAttribute("href")) {
            vue.$router.push({
              path: _target.getAttribute("href").replace("#/", "/")
            });
          }
        },
        pressHandler: function(e) {
          const infoBoxs = vue.$el.querySelectorAll(
            ".ksm-gummi__end-overlay.dragging"
          );
          if (infoBoxs) {
            infoBoxs.forEach(ib => {
              if (ib !== infobox) {
                ib.classList.remove("dragging");
              }
            });
          }
          infobox.classList.add("dragging");
          vue.zIndex++;
          infobox.style.zIndex = vue.zIndex;

          const line = vue.$el.querySelector(
            '.ksm-gummi__line[data-gummi-id="' + gummiID + '"]'
          );
          const lines = vue.$el.querySelectorAll(".ksm-gummi__line.dragging");
          if (lines) {
            lines.forEach(l => {
              if (l !== line) {
                l.classList.remove("dragging");
              }
            });
          }

          line.classList.add("dragging");
          this.userData = {
            startPoint: viewport.pointFromPixel(e.position)
          };
        },

        dragHandler: function(e) {
          //set infobox coordinate
          const pointFromPixel = viewport.pointFromPixel(e.position);
          const ol = viewer.getOverlayById(infobox);
          const bounds = ol.getBounds(viewport);
          const newPoint = new OpenSeadragon.Point(
            bounds.x + pointFromPixel.x - this.userData.startPoint.x,
            bounds.y + pointFromPixel.y - this.userData.startPoint.y
          );
          viewer.updateOverlay(infobox, newPoint);
          vue._resetLineEnd(infobox);
          infoFensterData.position = {
            x: newPoint.x,
            y: newPoint.y
          };
        }
      }).setTracking(true);

      if (infoFensterData.position === undefined) {
        //init infobox Position
        const containerSize = viewport.containerSize;
        const imageSize = viewer.world.getItemAt(0).getContentSize();
        const imagePoint = viewport.viewportToImageCoordinates(
          viewport.pointFromPixel(event.position, false)
        );

        const infoBoxs = vue.$el.querySelectorAll(".ksm-gummi__end-overlay");
        const len = infoBoxs ? infoBoxs.length + 1 : 1;
        let initPixel;
        if (imageSize.x / 2 < imagePoint.x) {
          //right
          initPixel = new OpenSeadragon.Point(
            containerSize.x - 10 * len - 200,
            10 * len
          );
        } else {
          initPixel = new OpenSeadragon.Point(10 * len, 10 * len);
        }
        initPixel.y = event.position.y - 10;
        const point = viewport.pointFromPixel(initPixel, false);
        infoFensterData.position = {
          x: point.x,
          y: point.y
        };
        vue.$store.commit("modus/updatePopupBoxList", {
          modusOption: vue.modusOption,
          data: infoFensterData
        });
      }

      this.viewer.addOverlay({
        element: infobox,
        x: infoFensterData.position.x,
        y: infoFensterData.position.y
      });

      vue._createLine(infobox);
    },

    /**
     *
     */
    _createLine(infobox) {
      const vue = this;
      const viewer = this.viewer;
      const viewport = viewer.viewport;
      const gummiID = infobox.getAttribute("data-gummi-id");
      const accoID = infobox.getAttribute("data-accoid");
      const tr_id = gummiID.split("#")[1];
      const start_overlay = this.$el.querySelector(
        '.ksm-gummi__start-overlay[data-tr-id="' + tr_id + '"]'
      );

      const line = this.$svgRootG
        .append("line")
        .attr("class", "ksm-gummi__line")
        .attr(
          "stroke-width",
          viewport.imageToViewportCoordinates(new OpenSeadragon.Point(20, 0)).x
        )
        .attr("data-gummi-id", gummiID)
        .attr("data-accoid", accoID);

      const circle = this.$svgRootG
        .append("circle")
        .attr("class", "ksm-gummi__start-circle")
        .attr("data-gummi-id", gummiID);

      vue._redrawOneLine({
        start: start_overlay,
        circle: circle,
        line: line,
        end: infobox
      });
    },

    /**
     *
     */
    _redrawAllLine() {
      if (this.stopRedrawAllLine) {
        this.stopRedrawAllLine = false;
        return;
      }

      const { viewerContanier } = this;
      const vue = this;
      const end_overlays = viewerContanier.querySelectorAll(
        ".ksm-gummi__end-overlay[data-gummi-id]"
      );

      if (end_overlays) {
        end_overlays.forEach(end => {
          const gummiID = end.getAttribute("data-gummi-id");
          const start = viewerContanier.querySelector(
            '.ksm-gummi__start-overlay[data-tr-id="' +
              gummiID.split("#")[1] +
              '"]'
          );
          const circle = viewerContanier.querySelector(
            '.ksm-gummi__start-circle[data-gummi-id="' + gummiID + '"]'
          );
          const line = viewerContanier.querySelector(
            '.ksm-gummi__line[data-gummi-id="' + gummiID + '"]'
          );

          vue._redrawOneLine({
            start: start,
            circle: d3.select(circle),
            line: d3.select(line),
            end: end
          });
        });
      }
    },

    _redrawOneLine({ start, end, line, circle }) {
      this._resetLineStart(start, line, circle);
      this._resetLineEnd(end, line);
    },

    /**
     *
     */
    _resetLineStart(start_overlay, line, circle) {
      if (!start_overlay) {
        return;
      }
      const ol = this.viewer.getOverlayById(start_overlay);
      if (!ol) {
        return;
      }
      const bounds = ol.getBounds(this.viewer.viewport);
      const zoom = this.viewer.viewport.getZoom();

      line
        .attr("x1", Number(bounds.x))
        .attr("y1", Number(bounds.y))
        .attr("stroke-width", bounds.width / 20);
      circle
        .attr("cx", Number(bounds.x))
        .attr("cy", Number(bounds.y))
        .attr("r", bounds.width / 10)
        .attr("stroke-width", bounds.width / 20);
    },

    /**
     * end_overlay ist infobox
     *
     */
    _resetLineEnd(end_overlay, line) {
      if (!end_overlay) {
        return;
      }
      const viewer = this.viewer;
      const gummiID = end_overlay.getAttribute("data-gummi-id");
      const ol = viewer.getOverlayById(end_overlay);
      if (!ol) {
        return;
      }
      const bounds = ol.getBounds(viewer.viewport);

      //set line endPoint
      if (!line) {
        line = this.$el.querySelector(
          '.ksm-gummi__line[data-gummi-id="' + gummiID + '"]'
        );
        line = d3.select(line);
      }
      line
        .attr("x2", Number(bounds.x) + Number(bounds.width / 2))
        .attr("y2", Number(bounds.y) + Number(bounds.height / 2));
    },

    /**
     *
     */
    _getPointDifference(x1, y1, x2, y2) {
      const viewport = this.viewer.viewport;
      const offset1 = viewport.pointFromPixel(
        new OpenSeadragon.Point(x1, y1),
        false
      );
      const offset2 = viewport.pointFromPixel(
        new OpenSeadragon.Point(x2, y2),
        false
      );
      return {
        x: Number(offset2.x) - Number(offset1.x),
        y: Number(offset2.y) - Number(offset1.y)
      };
    },

    /**
     *
     */
    _createPointByPixel(x, y) {
      return this.viewer.viewport.pointFromPixel(
        new OpenSeadragon.Point(),
        false
      );
    },

    /**
     *
     */
    _openInfoBox(infoFensterData, event) {
      const { gummiID } = infoFensterData;
      const infoboxs = this.$el.querySelectorAll(".ksm-gummi__end-overlay");
      let opened = false;
      if (infoboxs) {
        infoboxs.forEach(ibox => {
          if (ibox.getAttribute("data-gummi-id") === gummiID) {
            opened = true;
            return;
          }
        });
      }
      if (opened) {
        return;
      }

      this._createInfoBox(infoFensterData, event);
    },

    /**
     *
     */
    _setPopupBox(checkedTranscriptKategorieMap) {
      if (!this.accordionidTranscriptMap || !this.modusOption.popupBoxList) {
        return;
      }
      const vue = this;
      const trIds = Object.keys(checkedTranscriptKategorieMap);
      const { merzId, seiteIdx } = this.modusOption.urlparams;
      const _createInfoBox = this._createInfoBox;
      this.modusOption.popupBoxList
        .filter(p => p.merzId === merzId && p.seiteIdx === seiteIdx)
        .forEach(d => {
          const tr_id = d.gummiID.split("#")[1];
          if (
            trIds.indexOf(tr_id) > -1 &&
            !vue.$el.querySelector('[data-gummi-id="' + d.gummiID + '"')
          ) {
            _createInfoBox(d);
          }
        });

      const checkedKategorieAccordionIDs = this.checkedKategorieAccordionIDs;
      const lines = this.$el.querySelectorAll("*[data-gummi-id]");
      for (const l of lines) {
        const gummi_id = l.getAttribute("data-gummi-id");
        const accoID = l.getAttribute("data-accoid");
        const tr_id = gummi_id.split("#")[1];
        if (
          trIds.indexOf(tr_id) < 0 ||
          checkedKategorieAccordionIDs.indexOf(accoID) < 0
        ) {
          l.classList.add("ksm-gummi-hide");
        } else {
          l.classList.remove("ksm-gummi-hide");
        }
      }
    },

    /**
     *
     */
    _getMenuPosition(pos) {
      const [px, py] = [pos.x, pos.y];
      const { x, y } = this.viewer.viewport.containerSize;
      const [w, h] = [200, 100];

      if (x - px > w && y - py > h) {
        return "bottom";
      } else if (x - px > w && y - py < h) {
        return "top";
      } else if (x - px < w && y - py < h) {
        return "left-top";
      } else if (x - px < w && y - py > h) {
        return "left";
      }
    },

    /**
     *
     */
    _createMenu(event) {
      const rect = event.originalEvent.target;
      const div = rect.parentNode.parentNode.parentNode;
      const trID = div.getAttribute("data-tr-id");
      const obj = this.checkedTranscriptKategorieMap[trID];
      const vue = this;
      const tr = obj.data;
      const el = document.createElement("div");
      const accordionList = vue.modusOption.accordionList;

      if (obj.accoItems.length === 1) {
        const item = obj.accoItems[0];
        this._openInfoBox(
          {
            accoItemIdx: item.accoItemIdx,
            accoID: item.acco,
            gummiID: "0#" + trID
          },
          event
        );
        return;
      }

      const pos = this._getMenuPosition(event.position);
      obj.accoItems.forEach((item, i) => {
        const accoId = item.acco;
        const ac = accordionList.find(ac => ac.id === accoId);
        const div2 = document.createElement("div");
        const div3 = document.createElement("div");
        const div4 = document.createElement("div");
        div2.appendChild(div3);
        div2.appendChild(div4);
        div2.className = "ksm-flex";
        div3.className =
          "ksm-deepzoom__popupmenu__color-rect " + accoId + " _bg";
        div4.className = "ksm-deepzoom__popup-menuitem";
        div4.setAttribute("data-gummi-id", i + "#" + trID);
        div4.setAttribute("data-acco-id", accoId);
        div4.setAttribute("data-accoItem-idx", item.accoItemIdx);
        div4.innerHTML = ac.label;
        el.appendChild(div2);
      });
      el.className = "ksm-deepzoom__popupmenu-overlay __" + pos;
      this.viewer.addOverlay({
        element: el,
        px: tr.x,
        py: tr.y
      });
    },

    /**
     *
     */
    _drawOneColorRect(el, tr, accoItems) {
      if (accoItems.length < 0) {
        return;
      }
      //eindeutig
      const accoArr = accoItems.filter(
        (ac, i, self) => accoItems.indexOf(ac) === i
      );
      const g = d3
        .select(el)
        .append("svg")
        .attr("class", "svg-overlay")
        .attr("width", "100%")
        .attr("height", "100%")
        .append("g");

      switch (accoArr.length) {
        case 1:
          accoArr.forEach((ac, i) => {
            g.append("rect")
              .attr("width", "100%")
              .attr("height", "100%")
              .attr("class", "kategorie-rect  " + ac.acco);
          });
          break;

        case 2:
          accoArr.forEach((ac, i) => {
            g.append("rect")
              .attr("width", "50%")
              .attr("height", "100%")
              .attr("x", function() {
                return i == 0 ? 0 : "50%";
              })
              .attr("class", "kategorie-rect " + ac.acco);
          });
          break;

        case 3:
          accoArr.forEach((ac, i) => {
            g.append("rect")
              .attr("width", "50%")
              .attr("height", function() {
                if (i == 2) {
                  return "60%";
                } else {
                  return "100%";
                }
              })
              .attr("x", function() {
                if (i == 0) {
                  return "0";
                } else if (i == 1) {
                  return "50%";
                } else if (i == 2) {
                  return "30%";
                }
              })
              .attr("y", function() {
                if (i == 2) {
                  return "20%";
                } else {
                  return "0";
                }
              })
              .attr("class", "kategorie-rect " + ac.acco);
          });
          break;

        case 4:
          accoArr.forEach((ac, i) => {
            g.append("rect")
              .attr("width", "50%")
              .attr("height", "50%")
              .attr("x", function() {
                if (i == 0) {
                  return "0";
                } else if (i == 1) {
                  return "50%";
                } else if (i == 2) {
                  return "0";
                } else if (i == 3) {
                  return "50%";
                }
              })
              .attr("y", function() {
                if (i == 0) {
                  return "0";
                } else if (i == 1) {
                  return "0";
                } else if (i == 2) {
                  return "50%";
                } else if (i == 3) {
                  return "50%";
                }
              })
              .attr("class", "kategorie-rect " + ac.acco);
          });
          break;

        case 5:
          accoArr.forEach((ac, i) => {
            g.append("rect")
              .attr("width", "50%")
              .attr("height", function() {
                if (i == 5) {
                  return "60%";
                } else {
                  return "50%";
                }
              })
              .attr("x", function() {
                if (i == 0) {
                  return "0";
                } else if (i == 1) {
                  return "50%";
                } else if (i == 2) {
                  return "0";
                } else if (i == 3) {
                  return "50%";
                } else if (i == 4) {
                  return "30%";
                }
              })
              .attr("y", function() {
                if (i == 0) {
                  return "0";
                } else if (i == 1) {
                  return "0";
                } else if (i == 2) {
                  return "50%";
                } else if (i == 3) {
                  return "50%";
                } else if (i == 4) {
                  return "20%";
                }
              })
              .attr("class", "kategorie-rect " + ac.acco);
          });
          break;
      }

      this.viewer.addOverlay({
        element: el,
        px: tr.x,
        py: tr.y
      });
    },

    /**
     *
     */
    _drawCanvasOverlayers(canvasOverlay, data) {
      if (!this.openedSeite) {
        return;
      }

      if (!data) {
        data = [];
      }

      const vue = this;
      const isMarked = canvasOverlay === this.canvasoverlay_marked;
      canvasOverlay.resize();
      canvasOverlay.onRedraw = function() {
        const ctx = canvasOverlay.context2d();
        if (isMarked) {
          //add mask
          if (vue.isUntersuchung) {
            ctx.fillStyle = "#eee";
            ctx.globalAlpha = vue.transparenz;
            ctx.fillRect(0, 0, canvasOverlay.imgWidth, canvasOverlay.imgHeight);
            ctx.globalAlpha = 1;
          }
          ctx.strokeStyle = "rgba(153,0,0,7)";
        } else {
          ctx.fillStyle = "rgba(153,0,0,0.3)";
        }
        data.forEach(d => {
          //thema color
          if (d.$_color) {
            ctx.globalAlpha = 0.6;
            // if (isMarked) {
            // ctx.strokeStyle = d.$_color;
            // } else {
            ctx.fillStyle = d.$_color;
            ctx.fillRect(d.x, d.y, d.w, d.h);
            return;
            // }
          }
          if (isMarked) {
            ctx.clearRect(d.x, d.y, d.w, d.h);
            ctx.lineWidth = "4";
            ctx.strokeRect(d.x, d.y, d.w, d.h);
          } else {
            ctx.fillRect(d.x, d.y, d.w, d.h);
          }
        });
      };
      canvasOverlay.resize();
      canvasOverlay._updateCanvas();
    },

    /**
     *
     */
    _getTranslate(element) {
      const style = getComputedStyle(element);
      const regExp = "/matrix((d+,s){4}(d+),s(d+)/i";
      const result = style.transform.match(regExp);
      if (result) {
        return {
          x: parseInt(result[2], 10),
          y: parseInt(result[3], 10)
        };
      } else {
        return {
          x: 0,
          y: 0
        };
      }
    },

    /**
     *
     */
    _initViewer() {
      const tiles = this.tiles;
      const vue = this;
      const id = this.containerId;
      const viewerContanier = vue.$el.querySelector("#" + id);
      const toolbarDiv = vue.$el.querySelector(".toolbarDiv");
      vue.viewerContanier = viewerContanier;

      if (!toolbarDiv || !viewerContanier) {
        return;
      }

      const isKomposition = this.isKomposition;
      const viewer = new OpenSeadragon({
        element: viewerContanier,
        prefixUrl: "./static/openseadragon_images/",
        tileSources: tiles,
        initialPage: vue.seiteIdx,
        toolbar: toolbarDiv,
        showRotationControl: isKomposition ? false : true,
        showSequenceControl: isKomposition ? false : true,
        autoHideControls: false,
        // minZoomImageRatio: isKomposition ? 0.6 : 0.8,
        // minZoomLevel:0.2,
        gestureSettingsTouch: {
          pinchRotate: true
        },
        sequenceMode: true
      });

      if (isKomposition) {
        viewer.setControlsEnabled(false);
      }
      viewer.gestureSettingsMouse.clickToZoom = false;
      viewer.addHandler("open", function(event) {
        const _curr = vue.tiles[vue.viewer.currentPage()];
        if (
          _curr.indexOf("que_06842362_Bl.2v, Bl.3r") > -1 ||
          _curr.indexOf("que_06842362_Bl.3v, Cvin") > -1
        ) {
          viewer.viewport.setRotation(-180);
        } else {
          viewer.viewport.setRotation(0);
        }
        viewer.clearOverlays();
        if (vue.$svgRootG) {
          vue.$svgRootG.selectAll("*").remove();
        }

        const openedSeite = vue.seiten.find(s => {
          return s.deepSrc === event.source;
        });

        vue.openedSeite = openedSeite;
        if (openedSeite.$_allTranscripts) {
          vue.updateDataForCurrentView(openedSeite);
          vue.$emit("imageOpened");
          return;
        }

        vue.$store.dispatch("fechtSeiteDocs", openedSeite).then(res => {
          if (vue.modusOption.key === "ansicht") {
            return;
          }
          if (openedSeite.$_allTranscripts) {
            //verschiedene sidebar benutzt unterschiedlische Teile von all Transcripts
            //init für alle modus view vorbreitet.
            vue.updateDataForCurrentView(openedSeite);
          }

          vue.$emit("imageOpened");
        });
        if (vue.isUntersuchung) {
          vue._setTransparent();
        }
      });

      viewer.addHandler("canvas-click", function(e) {
        vue._canvasClick(e);
      });

      //  viewer.addHandler("canvas-double-click", function(e) {
      // vue.$emit('eventFromOSDViewer', {
      //   type: 'canvas-double-click',
      //   data: vue.mouseTargetTranscripts
      // });
      // vue.mouseTargetTranscripts.forEach(tr => {
      //   const pos = viewer.viewport.imageToViewerElementCoordinates(
      //     new OpenSeadragon.Point(tr.x, tr.y)
      //   );
      //   const viewportZoom = viewer.viewport.getZoom(true);
      //   const rotate = viewer.viewport.getRotation();
      //   const image1 = viewer.world.getItemAt(0);
      //   const zoom = image1.viewportToImageZoom(viewportZoom);

      //   const [x, y, w, h] = [
      //     Number(pos.x),
      //     Number(pos.y),
      //     tr.w * zoom,
      //     tr.h * zoom
      //   ];

      //   if (x < 0 || y < 0 || w <= 0 || h <= 0) {
      //     return;
      //   }
      //   viewer.drawer.context.strokeStyle = 'red';
      //   viewer.drawer.context.rect(x, y, w, h);
      //   viewer.drawer.context.stroke();
      // });
      // });

      viewer.addHandler("zoom", function() {
        vue._removeAllDraggableElement();
        vue._redrawAllLine();
        vue.$emit("eventFromOSDViewer", {
          type: "zoom",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      viewer.addHandler("canvas-drag", function() {
        vue.$emit("eventFromOSDViewer", {
          type: "canvas-drag",
          zoom: viewer.viewport.getZoom(),
          center: viewer.viewport.getCenter()
        });
      });

      //set mouse event
      //set mouseTargetTranscript and relatedID
      const mousemoveSubject = new Subject();
      from(mousemoveSubject)
        .pipe(map(pos => vue._getTranscriptsUnderMouse(pos)))
        .pipe(debounceTime(15))
        .pipe(
          distinctUntilChanged(function(a, b) {
            if (a === b) {
              return true;
            }

            if (a && b && a.length === b.length) {
              let has = true;
              b.forEach((d, i) => {
                if (a[i].id !== d.id) {
                  has = false;
                }
              });
              return has;
            }
          })
        )
        .subscribe(trs => {
          vue.mouseTargetTranscripts = trs;
          vue.mouseRelatedTranscriptIDs = [];
          vue.mouseTargetAccoItems = [];
          if (isKomposition && vue.modusOption.viewKey !== "ursonate_noten") {
            vue._drawDraggleTranscripts(trs);
            vue.$store.state.eventBus.$emit(
              [
                "mouseover.transcripts.komposition",
                this.modusOption.viewKey,
                this.modusOption.key
              ].join("-"),
              trs
            );
            return;
          }
          trs &&
            trs.forEach(tr => {
              vue.mouseTargetAccoItems = vue._getTargetAccoItems(tr.id);
              vue.mouseRelatedTranscriptIDs = vue.mouseRelatedTranscriptIDs.concat(
                vue._getRelatedTranscriptIDs(tr.id)
              );
            });
        });

      viewerContanier.addEventListener("mouseout", function() {
        mousemoveSubject.next(null);
      });
      this.mouseTracker = new OpenSeadragon.MouseTracker({
        element: viewerContanier,
        moveHandler: function(e) {
          // nur wenn daten geladen
          if (!vue.openedSeite) {
            return;
          }
          mousemoveSubject.next(e.position);
        },
        keyDownHandler: function(e) {
          viewer.setMouseNavEnabled(false);
        },
        keyUpHandler: function(e) {
          viewer.setMouseNavEnabled(true);
        }
      }).setTracking(true);

      if (!isKomposition) {
        //openseadragon controls button previus
        viewer.previousButton.addHandler("click", function(e) {
          let idx = vue.seiteIdx;
          if (idx > 0) {
            vue.stopDobbledrawTranscripts = true;
            vue.$emit("changePage", idx - 1);
          }
        });
        //openseadragon controls button next
        viewer.nextButton.addHandler("click", function(e) {
          let idx = vue.seiteIdx;
          if (idx < vue.seiten.length - 1) {
            vue.stopDobbledrawTranscripts = true;
            vue.$emit("changePage", idx + 1);
          }
        });
      }

      //add Canvas Overlay
      vue.canvasoverlay_checked = new CanvasOverlay(viewer, {
        clearBeforeRedraw: true,
        id: "checked"
      });
      vue.canvasoverlay_mouseover = new CanvasOverlay(viewer, {
        clearBeforeRedraw: true,
        id: "mouseover"
      });
      vue.canvasoverlay_marked = new CanvasOverlay(viewer, {
        clearBeforeRedraw: true,
        id: "marked"
      });

      const updateViewportSubject = new Subject();
      from(updateViewportSubject)
        .pipe(debounceTime(500))
        .subscribe(e => {
          vue.$emit("updateViewport");
        });

      viewer.addHandler("update-viewport", function(e) {
        updateViewportSubject.next(e);
      });

      //add svg Overlay
      this.$svgRootG = d3.select(viewer.svgOverlay().node());
      this.viewer = viewer;
    }
  }
};
</script>

<style lang="scss">
.ksm-deepzoom__page-wrapper {
  @extend .ksm-flex-1;
  position: relative;
  height: 100%;
  background-color: #eee;
}

.ksm-deepzoom__page {
  position: relative;
  width: 100%;
  height: 100%;
}
.ksm-deepzoom__body {
  // @extend .ksm-position-absolute;
  border: 1px solid #fff;
}

.ksm-gummi__start-overlay {
  width: 20px;
  height: 20px;
  border: 1px solid #fff;
  opacity: 0.9;
  z-index: 100;
  cursor: pointer;
}

.ksm-deepzoom__popupmenu-overlay {
  background-color: #eee;
  // position: absolute;
  //margin-top: 25px;
  padding: 3px;
  border: 2px solid #fff;
  z-index: 4000;

  &.__left-top {
    margin-bottom: 25px;
    transform: translate(-100%, -100%);
  }

  &.__top {
    margin-top: -5px;
    transform: translateY(-100%);
  }

  &.__bottom {
    margin-top: 25px;
  }

  &.__left {
    margin-left: -5px;
    transform: translateX(-100%);
  }
}

.ksm-deepzoom__popupmenu__color-rect {
  width: 10px;
  height: 10px;
  margin: 3px 5px;
}

.ksm-gummi__end-overlay {
  background-color: #eee;
  border: 2px solid $darkGrey;
  //z-index: 2000;
  width: 220px;
  font-size: 9pt;
  line-height: 1.5em;
  // &.dragging {
  //  z-index: 2001;
  // }
  border-radius: 5px;
  -webkit-box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
  box-shadow: 9px 7px 13px -1px rgba(0, 0, 0, 0.75);
  @extend .ksm-flex-column;

  .__head {
    padding-top: 5px;
  }
  .__body {
    padding: 5px;
    max-height: 200px;
    overflow: auto;
  }
  .__close-infobox {
    padding: 0px 10px;
    &:hover {
      cursor: pointer;
    }
  }
  &.untersuchung {
    a {
      color: $untersuchung-color !important;
    }
  }
}

.ksm-gummi-hide {
  visibility: hidden;
}

.ksm-gummi__line {
  stroke: $darkRed;
  z-index: 2000;
  &.dragging {
    z-index: 3000;
  }
}
.ksm-gummi__start-circle {
  stroke: $darkGrey;
  fill: transparent;
}

.ksm-deepzoom__popup-menuitem {
  font-size: 9pt;
  &:hover {
    color: blue;
  }
  cursor: pointer;
}

.ksm-komposition__focus-transcript {
  border: 1px solid $darkRed;
  z-index: 2003;
  position: absolute;
  cursor: all-scroll;
}

.ksm-komposition__draggable-div {
  position: absolute;
  background-color: rgba(179, 104, 104, 0.75);
  width: 100%;
  height: 100%;
  z-index: 2004;
}
.ksm-komposition__fly-div {
  -webkit-transition: left 0.5s;
  transition: left 0.5s;
}
</style>


// WEBPACK FOOTER //
// DeepzoomView.vue?d91a49b2